// source: witbooking/backoffice/condition/v1/condition_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.witbooking.backoffice.condition.v1.Condition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.condition.v1.GetConditionsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.condition.v1.GetConditionsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.condition.v1.LegacyCondition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.condition.v1.LegacyTranslation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.condition.v1.GetConditionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.condition.v1.GetConditionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.condition.v1.GetConditionsRequest.displayName = 'proto.witbooking.backoffice.condition.v1.GetConditionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.condition.v1.GetConditionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.condition.v1.GetConditionsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.condition.v1.GetConditionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.condition.v1.GetConditionsResponse.displayName = 'proto.witbooking.backoffice.condition.v1.GetConditionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest.displayName = 'proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.displayName = 'proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest.displayName = 'proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.displayName = 'proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest.displayName = 'proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse.displayName = 'proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.condition.v1.LegacyCondition.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.condition.v1.LegacyCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.condition.v1.LegacyCondition.displayName = 'proto.witbooking.backoffice.condition.v1.LegacyCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.condition.v1.LegacyTranslation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.condition.v1.LegacyTranslation.displayName = 'proto.witbooking.backoffice.condition.v1.LegacyTranslation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.condition.v1.Condition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.condition.v1.Condition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.condition.v1.Condition.displayName = 'proto.witbooking.backoffice.condition.v1.Condition';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.condition.v1.GetConditionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.condition.v1.GetConditionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.condition.v1.GetConditionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.GetConditionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.condition.v1.GetConditionsRequest}
 */
proto.witbooking.backoffice.condition.v1.GetConditionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.condition.v1.GetConditionsRequest;
  return proto.witbooking.backoffice.condition.v1.GetConditionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.condition.v1.GetConditionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.condition.v1.GetConditionsRequest}
 */
proto.witbooking.backoffice.condition.v1.GetConditionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.condition.v1.GetConditionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.condition.v1.GetConditionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.condition.v1.GetConditionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.GetConditionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.condition.v1.GetConditionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.condition.v1.GetConditionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.condition.v1.GetConditionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.condition.v1.GetConditionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.GetConditionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    conditionsList: jspb.Message.toObjectList(msg.getConditionsList(),
    proto.witbooking.backoffice.condition.v1.Condition.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.condition.v1.GetConditionsResponse}
 */
proto.witbooking.backoffice.condition.v1.GetConditionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.condition.v1.GetConditionsResponse;
  return proto.witbooking.backoffice.condition.v1.GetConditionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.condition.v1.GetConditionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.condition.v1.GetConditionsResponse}
 */
proto.witbooking.backoffice.condition.v1.GetConditionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.condition.v1.Condition;
      reader.readMessage(value,proto.witbooking.backoffice.condition.v1.Condition.deserializeBinaryFromReader);
      msg.addConditions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.condition.v1.GetConditionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.condition.v1.GetConditionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.condition.v1.GetConditionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.GetConditionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConditionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.condition.v1.Condition.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Condition conditions = 1;
 * @return {!Array<!proto.witbooking.backoffice.condition.v1.Condition>}
 */
proto.witbooking.backoffice.condition.v1.GetConditionsResponse.prototype.getConditionsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.condition.v1.Condition>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.condition.v1.Condition, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.condition.v1.Condition>} value
 * @return {!proto.witbooking.backoffice.condition.v1.GetConditionsResponse} returns this
*/
proto.witbooking.backoffice.condition.v1.GetConditionsResponse.prototype.setConditionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.condition.v1.Condition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.condition.v1.Condition}
 */
proto.witbooking.backoffice.condition.v1.GetConditionsResponse.prototype.addConditions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.condition.v1.Condition, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.condition.v1.GetConditionsResponse} returns this
 */
proto.witbooking.backoffice.condition.v1.GetConditionsResponse.prototype.clearConditionsList = function() {
  return this.setConditionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    condition: (f = msg.getCondition()) && proto.witbooking.backoffice.condition.v1.LegacyCondition.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest}
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest;
  return proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest}
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.condition.v1.LegacyCondition;
      reader.readMessage(value,proto.witbooking.backoffice.condition.v1.LegacyCondition.deserializeBinaryFromReader);
      msg.setCondition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCondition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.condition.v1.LegacyCondition.serializeBinaryToWriter
    );
  }
};


/**
 * optional LegacyCondition condition = 1;
 * @return {?proto.witbooking.backoffice.condition.v1.LegacyCondition}
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest.prototype.getCondition = function() {
  return /** @type{?proto.witbooking.backoffice.condition.v1.LegacyCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.condition.v1.LegacyCondition, 1));
};


/**
 * @param {?proto.witbooking.backoffice.condition.v1.LegacyCondition|undefined} value
 * @return {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest} returns this
*/
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest.prototype.setCondition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest} returns this
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest.prototype.clearCondition = function() {
  return this.setCondition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionRequest.prototype.hasCondition = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    condition: (f = msg.getCondition()) && proto.witbooking.backoffice.condition.v1.LegacyCondition.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse}
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse;
  return proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse}
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.condition.v1.LegacyCondition;
      reader.readMessage(value,proto.witbooking.backoffice.condition.v1.LegacyCondition.deserializeBinaryFromReader);
      msg.setCondition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCondition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.condition.v1.LegacyCondition.serializeBinaryToWriter
    );
  }
};


/**
 * optional LegacyCondition condition = 1;
 * @return {?proto.witbooking.backoffice.condition.v1.LegacyCondition}
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.prototype.getCondition = function() {
  return /** @type{?proto.witbooking.backoffice.condition.v1.LegacyCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.condition.v1.LegacyCondition, 1));
};


/**
 * @param {?proto.witbooking.backoffice.condition.v1.LegacyCondition|undefined} value
 * @return {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse} returns this
*/
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.prototype.setCondition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse} returns this
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.prototype.clearCondition = function() {
  return this.setCondition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.condition.v1.CreateLegacyConditionResponse.prototype.hasCondition = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    condition: (f = msg.getCondition()) && proto.witbooking.backoffice.condition.v1.LegacyCondition.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest}
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest;
  return proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest}
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.condition.v1.LegacyCondition;
      reader.readMessage(value,proto.witbooking.backoffice.condition.v1.LegacyCondition.deserializeBinaryFromReader);
      msg.setCondition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCondition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.condition.v1.LegacyCondition.serializeBinaryToWriter
    );
  }
};


/**
 * optional LegacyCondition condition = 1;
 * @return {?proto.witbooking.backoffice.condition.v1.LegacyCondition}
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest.prototype.getCondition = function() {
  return /** @type{?proto.witbooking.backoffice.condition.v1.LegacyCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.condition.v1.LegacyCondition, 1));
};


/**
 * @param {?proto.witbooking.backoffice.condition.v1.LegacyCondition|undefined} value
 * @return {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest} returns this
*/
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest.prototype.setCondition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest} returns this
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest.prototype.clearCondition = function() {
  return this.setCondition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionRequest.prototype.hasCondition = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    condition: (f = msg.getCondition()) && proto.witbooking.backoffice.condition.v1.LegacyCondition.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse}
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse;
  return proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse}
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.condition.v1.LegacyCondition;
      reader.readMessage(value,proto.witbooking.backoffice.condition.v1.LegacyCondition.deserializeBinaryFromReader);
      msg.setCondition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCondition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.condition.v1.LegacyCondition.serializeBinaryToWriter
    );
  }
};


/**
 * optional LegacyCondition condition = 1;
 * @return {?proto.witbooking.backoffice.condition.v1.LegacyCondition}
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.prototype.getCondition = function() {
  return /** @type{?proto.witbooking.backoffice.condition.v1.LegacyCondition} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.condition.v1.LegacyCondition, 1));
};


/**
 * @param {?proto.witbooking.backoffice.condition.v1.LegacyCondition|undefined} value
 * @return {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse} returns this
*/
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.prototype.setCondition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse} returns this
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.prototype.clearCondition = function() {
  return this.setCondition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.condition.v1.UpdateLegacyConditionResponse.prototype.hasCondition = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest}
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest;
  return proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest}
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest} returns this
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyConditionRequest.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse}
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse;
  return proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse}
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.DeleteLegacyPromotionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.condition.v1.LegacyCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.condition.v1.LegacyCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    codigo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    color: jspb.Message.getFieldWithDefault(msg, 3, ""),
    cobroanticipado: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    importeminimo: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    escobrarprimeranoche: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.condition.v1.LegacyTranslation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyCondition}
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.condition.v1.LegacyCondition;
  return proto.witbooking.backoffice.condition.v1.LegacyCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.condition.v1.LegacyCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyCondition}
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCodigo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCobroanticipado(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setImporteminimo(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEscobrarprimeranoche(value);
      break;
    case 7:
      var value = new proto.witbooking.backoffice.condition.v1.LegacyTranslation;
      reader.readMessage(value,proto.witbooking.backoffice.condition.v1.LegacyTranslation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.condition.v1.LegacyCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.condition.v1.LegacyCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCodigo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCobroanticipado();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getImporteminimo();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getEscobrarprimeranoche();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.witbooking.backoffice.condition.v1.LegacyTranslation.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyCondition} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string codigo = 2;
 * @return {string}
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.getCodigo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyCondition} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.setCodigo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string color = 3;
 * @return {string}
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyCondition} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double cobroanticipado = 4;
 * @return {number}
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.getCobroanticipado = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyCondition} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.setCobroanticipado = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double importeminimo = 5;
 * @return {number}
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.getImporteminimo = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyCondition} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.setImporteminimo = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional bool esCobrarPrimeraNoche = 6;
 * @return {boolean}
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.getEscobrarprimeranoche = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyCondition} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.setEscobrarprimeranoche = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * repeated LegacyTranslation translations = 7;
 * @return {!Array<!proto.witbooking.backoffice.condition.v1.LegacyTranslation>}
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.condition.v1.LegacyTranslation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.condition.v1.LegacyTranslation, 7));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.condition.v1.LegacyTranslation>} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyCondition} returns this
*/
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.witbooking.backoffice.condition.v1.LegacyTranslation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyTranslation}
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.witbooking.backoffice.condition.v1.LegacyTranslation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyCondition} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyCondition.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.condition.v1.LegacyTranslation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.condition.v1.LegacyTranslation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    htmlCancelaciones: jspb.Message.getFieldWithDefault(msg, 3, ""),
    htmlEntrada: jspb.Message.getFieldWithDefault(msg, 4, ""),
    htmlSalida: jspb.Message.getFieldWithDefault(msg, 5, ""),
    htmlCondNinos: jspb.Message.getFieldWithDefault(msg, 6, ""),
    htmlMascotas: jspb.Message.getFieldWithDefault(msg, 7, ""),
    htmlGrupos: jspb.Message.getFieldWithDefault(msg, 8, ""),
    htmlInfoAdicional: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyTranslation}
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.condition.v1.LegacyTranslation;
  return proto.witbooking.backoffice.condition.v1.LegacyTranslation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.condition.v1.LegacyTranslation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyTranslation}
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHtmlCancelaciones(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHtmlEntrada(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHtmlSalida(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setHtmlCondNinos(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setHtmlMascotas(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setHtmlGrupos(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setHtmlInfoAdicional(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.condition.v1.LegacyTranslation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.condition.v1.LegacyTranslation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHtmlCancelaciones();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHtmlEntrada();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHtmlSalida();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHtmlCondNinos();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getHtmlMascotas();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getHtmlGrupos();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getHtmlInfoAdicional();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyTranslation} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyTranslation} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string html_cancelaciones = 3;
 * @return {string}
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.getHtmlCancelaciones = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyTranslation} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.setHtmlCancelaciones = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string html_entrada = 4;
 * @return {string}
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.getHtmlEntrada = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyTranslation} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.setHtmlEntrada = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string html_salida = 5;
 * @return {string}
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.getHtmlSalida = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyTranslation} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.setHtmlSalida = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string html_cond_ninos = 6;
 * @return {string}
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.getHtmlCondNinos = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyTranslation} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.setHtmlCondNinos = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string html_mascotas = 7;
 * @return {string}
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.getHtmlMascotas = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyTranslation} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.setHtmlMascotas = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string html_grupos = 8;
 * @return {string}
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.getHtmlGrupos = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyTranslation} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.setHtmlGrupos = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string html_info_adicional = 9;
 * @return {string}
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.getHtmlInfoAdicional = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.condition.v1.LegacyTranslation} returns this
 */
proto.witbooking.backoffice.condition.v1.LegacyTranslation.prototype.setHtmlInfoAdicional = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.condition.v1.Condition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.condition.v1.Condition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.condition.v1.Condition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.Condition.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    legacyId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    inUse: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.condition.v1.Condition}
 */
proto.witbooking.backoffice.condition.v1.Condition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.condition.v1.Condition;
  return proto.witbooking.backoffice.condition.v1.Condition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.condition.v1.Condition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.condition.v1.Condition}
 */
proto.witbooking.backoffice.condition.v1.Condition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLegacyId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInUse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.condition.v1.Condition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.condition.v1.Condition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.condition.v1.Condition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.condition.v1.Condition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLegacyId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getInUse();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.condition.v1.Condition.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.condition.v1.Condition} returns this
 */
proto.witbooking.backoffice.condition.v1.Condition.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 legacy_id = 2;
 * @return {number}
 */
proto.witbooking.backoffice.condition.v1.Condition.prototype.getLegacyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.condition.v1.Condition} returns this
 */
proto.witbooking.backoffice.condition.v1.Condition.prototype.setLegacyId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool in_use = 3;
 * @return {boolean}
 */
proto.witbooking.backoffice.condition.v1.Condition.prototype.getInUse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.condition.v1.Condition} returns this
 */
proto.witbooking.backoffice.condition.v1.Condition.prototype.setInUse = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


goog.object.extend(exports, proto.witbooking.backoffice.condition.v1);
